/**
 * Venture — visual boost layer.
 * Purely additive: extends the theme's existing 3D-tilt system to the
 * product showcase cards, and adds a sticky mini buy bar on the product
 * page so the purchase action stays visible while the shopper scrolls.
 * Does not read from or modify theme.js / product-form.js — only listens
 * to the same public DOM (#ProductForm, #ProductAddToCart, #ProductPrice)
 * that product-form.js already exposes.
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  // --- 3D tilt + gloss on product showcase cards (desktop pointer only) ---
  function enableTilt(el) {
    if (!el) return;
    var raf = null;
    el.addEventListener('mousemove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var rect = el.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.setProperty('--tilt-y', (relX * 6).toFixed(2) + 'deg');
        el.style.setProperty('--tilt-x', (relY * -6).toFixed(2) + 'deg');
        el.style.setProperty('--gloss-x', (50 + relX * 60).toFixed(1) + '%');
        el.style.setProperty('--gloss-y', (50 + relY * 60).toFixed(1) + '%');
        raf = null;
      });
    });
    el.addEventListener('mouseleave', function () {
      ['--tilt-x', '--tilt-y', '--gloss-x', '--gloss-y'].forEach(function (prop) {
        el.style.removeProperty(prop);
      });
    });
  }
  if (!reduced && finePointer) {
    document.querySelectorAll('.product-card__media').forEach(enableTilt);
  }

  // --- Sticky mini buy bar (product page only) ---
  var addBtn = document.getElementById('ProductAddToCart');
  var form = document.getElementById('ProductForm');
  var priceWrap = document.getElementById('ProductPrice');
  var titleEl = document.querySelector('.product-info__title');

  if (!addBtn || !form || !priceWrap || !titleEl || !('IntersectionObserver' in window)) return;

  var bar = document.createElement('div');
  bar.className = 'sticky-buy';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<div class="sticky-buy__inner container">' +
      '<div class="sticky-buy__info">' +
        '<p class="sticky-buy__title"></p>' +
        '<div class="sticky-buy__price"></div>' +
      '</div>' +
      '<button type="button" class="btn btn--primary sticky-buy__cta"><span></span></button>' +
    '</div>';
  document.body.appendChild(bar);

  var titleNode = bar.querySelector('.sticky-buy__title');
  var priceNode = bar.querySelector('.sticky-buy__price');
  var ctaBtn = bar.querySelector('.sticky-buy__cta');
  var ctaLabel = ctaBtn.querySelector('span');

  function syncBar() {
    titleNode.textContent = titleEl.textContent;
    priceNode.innerHTML = priceWrap.innerHTML;
    var label = addBtn.querySelector('[data-add-label]');
    ctaLabel.textContent = label ? label.textContent : 'Buy now';
    ctaBtn.disabled = addBtn.disabled;
  }
  syncBar();

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(syncBar);
    observer.observe(priceWrap, { childList: true, subtree: true });
    observer.observe(addBtn, { attributes: true, childList: true, subtree: true });
  }

  ctaBtn.addEventListener('click', function () {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      addBtn.click();
    }
  });

  var visibilityObserver = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', scrolledPast);
      bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
    },
    { threshold: 0 }
  );
  visibilityObserver.observe(addBtn);
})();
